
// const IP='https://zhuanzhen.huayiyun.net:8888/api'
const IP='https://demo-zhuanzhen.huayiyun.net:8082/zhuanzhen-api'
// const IP='http://192.168.2.83:9000'

//接口
const domain={
    getImageCode:IP+'/zhuanzhen/getImageCode',//获取图形验证码
    getImgCodeState:IP+'/zhuanzhen/getImgCodeState',//验证码是否验证标志
    getLoginCode:IP+'/zhuanzhen/getLoginCode',//获取手机验证码


    loginDB:IP+'/zhuanzhen/db/login',//登录
    login:IP+'/zhuanzhen/login',//登录
    logout:IP+'/zhuanzhen/logout',//登录
    getBackPassword:IP+'/zhuanzhen/getBackPassword',//找回密码

    getVerificationCode:IP+'/zhuanzhen/getVerificationCode',//获取手机验证码
    getReadAndWriteOSS:IP+'/zhuanzhen/oss/getReadAndWriteOSS',//获取oss账户

    //个人中心
    modifyPersonalInfomation:IP+'/zhuanzhen/modifyPersonalInfomation',//修改个人信息保存
    getUserInfo:IP+'/zhuanzhen/getUserInfo',//获取个人资料
    modifyPassword:IP+'/zhuanzhen/modifyPassword',//修改个人密码

    //医院管理
    queryHosp:IP+'/zhuanzhen/admin/queryHosp',//查询医院信息
    updateHospInfo:IP+'/zhuanzhen/admin/updateHospInfo',//更新医院信息
    queryRoleList:IP+'/zhuanzhen/admin/queryRoleList',//查询全部角色列表
    queryUserFromHosp:IP+'/zhuanzhen/admin/queryUserFromHosp',//查询医生列表
    openAccount:IP+'/zhuanzhen/admin/openAccount',//医生开户
    queryUserInfo:IP+'/zhuanzhen/admin/queryUserInfo',//查询医生信息
    updateUserInfo:IP+'/zhuanzhen/admin/updateUserInfo',//更新用户信息
    resetPassword:IP+'/zhuanzhen/admin/resetPassword',//重置密码

    //公共信息
    caseStatus:IP+'/base/caseStatus',//获取病历状态列表
    transferPurpose:IP+'/base/transferPurpose',//获取转诊目的列表
    expenseType:IP+'/base/expenseType',//获取报销类型

    //转出管理
    storage:IP+'/case/storage',//保存病历
    listOut:IP+'/case/listOut',//查询转出列表
    get:IP+'/case/get',//查询转诊病历详情
    listParent:IP+'/hosp/listParent',//查询上级医院列表
    submit:IP+'/case/submit',//提交转诊单
    cancel:IP+'/case/cancel',//取消申请
    getTransferBill:IP+'/case/getTransferBill', //查询转诊单

    //转入管理
    listEnter:IP+'/case/listEnter',//查询转入列表
    confirm:IP+'/case/confirm',//确认接收
    refuse:IP+'/case/refuse',//拒绝接收
    reach:IP+'/case/reach',//确认到诊

    //统计
    queryAllHospStatistics:IP+'/statistics/queryAllHospStatistics',//查询全院统计信息
    queryUserStatistics:IP+'/statistics/queryUserStatistics',//个人统计
    listAllCase:IP+'/case/listAll',
}

export default domain





// WEBPACK FOOTER //
// ./src/service/getData.js